import axios from '../lib/axios'
import { getCsrfToken } from '../Util/postRequest'

export const registerMonthlyCourseApi = async (params) => {
  return await axios.post('/api/v1/monthly_course/credit_payment/register', params, {
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
  })
}

export const unregisterMonthlyCourseApi = async (params) => {
  return await axios.post('/api/v1/monthly_course/credit_payment/unregister', params, {
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
  })
}
